export const NO_LABEL: string = 'NO_LABEL'
export interface Label {
  labelText?: string
  /** Asterisk; ignored when isOptional. */
  isRequired?: boolean
  /** Grey "optional" badge; ignored when isRequired. */
  isOptional?: boolean
  /** Tooltip content next to the label. */
  tooltipText?: string
  /** Help text under the label. */
  inlineHelpText?: string
  /** Wrapped lines before ellipsis + full-label popover. Defaults to 2. */
  maxLines?: number
}

/**
 * Hide the * / (optional) marker on a read-only or disabled field — it expects nothing of the
 * user, so the marker would misread. isReadOnly is the shell's EFFECTIVE read-only, so a
 * prefilled field drops the marker while displaying and regains it on Edit.
 */
export function showsRequirednessMarker(state: {
  isReadOnly?: boolean
  isDisabled?: boolean
}): boolean {
  return !state.isReadOnly && !state.isDisabled
}
